<div class="vlab upcoming">
  <div class="up-hd">
    <div class="up-houses" *ngIf="auctions.length">
      <div class="up-house" *ngFor="let a of auctions">
        <b>{{ a.label }}</b> · {{ a.s.lots | number }} lots · closes {{ closesRange(a.s) }} ·
        <span class="strong">{{ a.s.with_reading | number }} with a reading</span>
      </div>
    </div>
    <p class="muted sm up-explain">
      Readings come from your confirmed readings, the PlatoCompare word list, the names list and a quick AI read.
      What you accept or reject is used for every later reading.
    </p>
    <p class="muted xs" *ngIf="data?.counts">
      {{ data.counts.with_reading | number }} with a reading · {{ data.counts.reviewed | number }} reviewed · {{ data.counts.lots | number }} lots in all
    </p>
  </div>

  <section class="vl-card up-list" aria-label="Upcoming auction lots">
    <div class="card-hd wrap">
      <h3>Upcoming lots <span class="muted sm" *ngIf="total">{{ total | number }}</span></h3>
      <div class="filters">
        <label class="sr" for="up-house">House</label>
        <select id="up-house" [(ngModel)]="house" (ngModelChange)="onFilterChange()">
          <option value="">All houses</option>
          <option *ngFor="let a of auctions" [value]="a.key">{{ a.label }}</option>
        </select>
        <label class="sr" for="up-has">Has a reading</label>
        <select id="up-has" [(ngModel)]="hasReading" (ngModelChange)="onFilterChange()">
          <option value="yes">With a reading</option>
          <option value="no">No reading</option>
          <option value="">All lots</option>
        </select>
        <label class="sr" for="up-review">Review</label>
        <select id="up-review" [(ngModel)]="review" (ngModelChange)="onFilterChange()">
          <option value="pending">Not reviewed</option>
          <option value="done">Reviewed</option>
          <option value="">Any review state</option>
        </select>
        <form class="q" (ngSubmit)="onFilterChange()">
          <label class="sr" for="up-q">Find a plate</label>
          <input id="up-q" name="q" [(ngModel)]="q" placeholder="Find plate" autocomplete="off" spellcheck="false" />
        </form>
      </div>
    </div>

    <div *ngIf="error" class="vl-banner err slim" role="alert">
      <span>{{ error }}</span>
      <button type="button" class="btn-ghost" (click)="load(page)">Retry</button>
    </div>
    <div *ngIf="loading && !lots.length" class="muted sm pad">Loading upcoming lots…</div>
    <div *ngIf="!loading && !error && !lots.length" class="muted sm pad">No lots match these filters.</div>

    <ol class="up-rows" *ngIf="lots.length" [class.loading]="loading">
      <li class="up-row" *ngFor="let l of lots; trackBy: trackLot" [class.done]="l.review || row(l).saved">
        <div class="up-lot">
          <span class="pchip plate-font">{{ l.display || l.registration }}</span>
          <span class="muted xs">{{ houseLabel(l.house) }} · {{ closes(l) }}</span>
        </div>

        <div class="up-reading">
          <ng-container *ngIf="l.reading as rd; else noReading">
            <span class="up-reads">{{ rd.reads_as || '—' }}</span>
            <span class="up-badges">
              <span class="badge-c" *ngIf="rd.category">{{ categoryLabel(rd.category) }}</span>
              <span class="badge-conf" *ngIf="rd.confidence" [ngClass]="'conf-' + rd.confidence">{{ rd.confidence }}</span>
              <span class="muted xs" *ngIf="rd.source">{{ rd.source }}</span>
            </span>
          </ng-container>
          <ng-template #noReading><span class="muted">No reading</span></ng-template>
          <span class="up-state" *ngIf="l.review && !row(l).saved">
            <span class="spill" [ngClass]="'rs-rev-' + l.review.decision">{{ decisionLabel(l.review.decision) }}</span>
            <span class="muted xs" *ngIf="l.review.reads_as"> as “{{ l.review.reads_as }}”</span>
          </span>
          <span class="muted xs up-note" *ngIf="l.owner_note?.why">Your note: “{{ l.owner_note.why }}”</span>
          <span class="muted xs" *ngIf="l.research_requested && !row(l).saved">Sent to research</span>
        </div>

        <div class="up-actions">
          <ng-container *ngIf="l.reading">
            <button type="button" class="btn-ghost act-acc" [disabled]="row(l).saving" (click)="decide(l, 'accepted')">Accept</button>
            <button type="button" class="btn-ghost" [class.on]="row(l).open === 'correct'" [attr.aria-expanded]="row(l).open === 'correct'"
                    [disabled]="row(l).saving" (click)="open(l, 'correct')">Correct</button>
            <button type="button" class="btn-ghost act-rej" [disabled]="row(l).saving" (click)="decide(l, 'rejected')">Reject</button>
          </ng-container>
          <button type="button" class="btn-ghost" [class.on]="row(l).open === 'why'" [attr.aria-expanded]="row(l).open === 'why'"
                  [disabled]="row(l).saving" (click)="open(l, 'why')">{{ l.owner_note?.why ? 'Edit why' : 'Add why' }}</button>
          <button type="button" class="btn-ghost" [disabled]="row(l).saving || !!l.research_requested" (click)="sendToResearch(l)">Don't know – send to research</button>
          <span class="saved" *ngIf="row(l).saved" role="status">{{ row(l).saved }}</span>
          <span class="muted xs" *ngIf="row(l).saving">Saving…</span>
          <span class="err-t xs" *ngIf="row(l).error" role="alert">{{ row(l).error }}</span>
        </div>

        <!-- inline: correct the reading -->
        <form class="up-inline" *ngIf="row(l).open === 'correct'" (ngSubmit)="decide(l, 'accepted', true)">
          <div class="fld">
            <label [attr.for]="'uc-' + l.key">Reads as</label>
            <input [id]="'uc-' + l.key" [name]="'uc-' + l.key" [(ngModel)]="row(l).readsAs" (keydown)="onKey($event, l, 'correct')" autocomplete="off" />
          </div>
          <div class="fld">
            <label [attr.for]="'ucc-' + l.key">Category</label>
            <select [id]="'ucc-' + l.key" [name]="'ucc-' + l.key" [(ngModel)]="row(l).category">
              <option value="">—</option>
              <option *ngFor="let c of categories" [value]="c.id">{{ c.label }}</option>
            </select>
          </div>
          <div class="up-inline-act">
            <button type="submit" class="btn-dark" [disabled]="row(l).saving || !row(l).readsAs.trim()">Save as accepted</button>
            <button type="button" class="btn-ghost" (click)="row(l).open = null">Cancel</button>
          </div>
        </form>

        <!-- inline: add why -->
        <div class="up-inline" *ngIf="row(l).open === 'why'">
          <div class="fld grow">
            <label [attr.for]="'uw-' + l.key">Why might it sell high?</label>
            <textarea [id]="'uw-' + l.key" rows="2" [(ngModel)]="row(l).why" (keydown)="onKey($event, l, 'why')"
                      placeholder="e.g. Ferrari F80 — F80 FER"></textarea>
          </div>
          <div class="up-inline-act">
            <button type="button" class="btn-dark" [disabled]="row(l).saving || !row(l).why.trim()" (click)="saveWhy(l)">Save note</button>
            <button type="button" class="btn-ghost" (click)="row(l).open = null">Cancel</button>
            <span class="muted xs hide-phone">Ctrl/⌘+Enter saves</span>
          </div>
        </div>
      </li>
    </ol>

    <div class="b-foot" *ngIf="lots.length || page > 1">
      <button type="button" class="btn-ghost" [disabled]="page <= 1 || loading" (click)="load(page - 1)">← Previous</button>
      <span class="muted sm">Page {{ page }} of {{ pages }}</span>
      <button type="button" class="btn-ghost" [disabled]="page >= pages || loading" (click)="load(page + 1)">Next 100 →</button>
    </div>
  </section>
</div>
